"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestEvent = exports.RequestData = exports.RequestSource = exports.getRequestSourceMetadata = exports.Request = exports.RequestFormPublic = exports.RequestForm = exports.RequestShoutout = exports.RequestError = exports.RequestDownload = exports.Shoutout = exports.ShoutoutQuantity = exports.ShoutoutFields = exports.ShoutoutAssets = exports.Asset = exports.RequestFormType = exports.RequestSourceType = exports.RequestStatus = exports.ShoutoutFeeMode = exports.ShoutoutAllocationMode = void 0;
const toccata_1 = require("@musicaudienceexchange/toccata");
var ShoutoutAllocationMode;
(function (ShoutoutAllocationMode) {
    /**
     * In this mode there is no limit to the number of requests that can be
     * purchased.
     */
    ShoutoutAllocationMode[ShoutoutAllocationMode["unlimited"] = 1] = "unlimited";
    /**
     * In this mode requests can only be purchased up until this date, after
     * which no more requests can be purchased.
     */
    ShoutoutAllocationMode[ShoutoutAllocationMode["date"] = 2] = "date";
    /**
     * In this mode only a fixed number of requests are allowed to be purchased.
     */
    ShoutoutAllocationMode[ShoutoutAllocationMode["quantity"] = 3] = "quantity";
})(ShoutoutAllocationMode = exports.ShoutoutAllocationMode || (exports.ShoutoutAllocationMode = {}));
var ShoutoutFeeMode;
(function (ShoutoutFeeMode) {
    ShoutoutFeeMode[ShoutoutFeeMode["flat"] = 1] = "flat";
    ShoutoutFeeMode[ShoutoutFeeMode["percent"] = 2] = "percent";
    ShoutoutFeeMode[ShoutoutFeeMode["custom"] = 3] = "custom";
})(ShoutoutFeeMode = exports.ShoutoutFeeMode || (exports.ShoutoutFeeMode = {}));
var RequestStatus;
(function (RequestStatus) {
    RequestStatus["pending"] = "pending";
    RequestStatus["received"] = "received";
    RequestStatus["expired"] = "expired";
    RequestStatus["viewed"] = "viewed";
    RequestStatus["rejected"] = "rejected";
    RequestStatus["processing"] = "processing";
    RequestStatus["failed"] = "failed";
    RequestStatus["completed"] = "completed";
    RequestStatus["refunded"] = "refunded";
    // This should be considered an error state
    RequestStatus["unknown"] = "unknown";
})(RequestStatus = exports.RequestStatus || (exports.RequestStatus = {}));
var RequestSourceType;
(function (RequestSourceType) {
    RequestSourceType["purchase"] = "purchase";
    RequestSourceType["reward"] = "reward";
    RequestSourceType["comp"] = "comp";
})(RequestSourceType = exports.RequestSourceType || (exports.RequestSourceType = {}));
var RequestFormType;
(function (RequestFormType) {
    RequestFormType["self"] = "self";
    RequestFormType["someoneElse"] = "someone_else";
})(RequestFormType = exports.RequestFormType || (exports.RequestFormType = {}));
class Asset extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString()
], Asset.prototype, "path", void 0);
exports.Asset = Asset;
class ShoutoutAssets extends toccata_1.Model {
}
__decorate([
    (0, toccata_1.TransformValidateModel)(Asset)
], ShoutoutAssets.prototype, "headerLarge", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(Asset)
], ShoutoutAssets.prototype, "headerSmall", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(Asset),
    toccata_1.validator.IsOptional()
], ShoutoutAssets.prototype, "icon", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(Asset),
    toccata_1.validator.IsOptional()
], ShoutoutAssets.prototype, "video", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(Asset),
    toccata_1.validator.IsOptional()
], ShoutoutAssets.prototype, "overlay", void 0);
exports.ShoutoutAssets = ShoutoutAssets;
class ShoutoutFields extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString({ each: true })
], ShoutoutFields.prototype, "starters", void 0);
exports.ShoutoutFields = ShoutoutFields;
class ShoutoutQuantity extends toccata_1.Model {
    constructor() {
        super(...arguments);
        /**
         * Total count of all purchased shoutouts
         */
        this.total = 0;
    }
}
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], ShoutoutQuantity.prototype, "limit", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], ShoutoutQuantity.prototype, "total", void 0);
exports.ShoutoutQuantity = ShoutoutQuantity;
class Shoutout extends toccata_1.Model {
    constructor() {
        super(...arguments);
        /**
         * Defines the methodology to use for determining when a Shoutout
         * is not longer available for purchase. See @see{ShoutoutAllocationMode}
         * for more details.
         */
        this.allocationMode = ShoutoutAllocationMode.unlimited;
        this.artistGroupName = '';
        this.feeMode = ShoutoutFeeMode.flat;
        this.introduction = '';
        this.processingFeeAmount = 0;
        this.responseTimeDays = 7;
        this.rules = '';
    }
}
__decorate([
    toccata_1.validator.IsEnum(ShoutoutAllocationMode)
], Shoutout.prototype, "allocationMode", void 0);
__decorate([
    toccata_1.validator.IsString()
], Shoutout.prototype, "artistGroupId", void 0);
__decorate([
    toccata_1.validator.IsString()
], Shoutout.prototype, "artistGroupName", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(ShoutoutAssets)
], Shoutout.prototype, "assets", void 0);
__decorate([
    toccata_1.validator.IsString()
], Shoutout.prototype, "billingAccountId", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Shoutout.prototype, "headerBackgroundColor", void 0);
__decorate([
    toccata_1.validator.IsBoolean(),
    toccata_1.validator.IsOptional()
], Shoutout.prototype, "hideSetliveHeaderLogo", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Shoutout.prototype, "createdAt", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Shoutout.prototype, "endedAt", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.ValidateIf((o) => o.allocationMode === ShoutoutAllocationMode.date)
], Shoutout.prototype, "endDate", void 0);
__decorate([
    toccata_1.validator.IsEnum(ShoutoutFeeMode)
], Shoutout.prototype, "feeMode", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(ShoutoutFields)
], Shoutout.prototype, "fields", void 0);
__decorate([
    toccata_1.validator.IsString({ each: true })
], Shoutout.prototype, "fulfillerUids", void 0);
__decorate([
    toccata_1.validator.IsString()
], Shoutout.prototype, "introduction", void 0);
__decorate([
    toccata_1.validator.IsString()
], Shoutout.prototype, "name", void 0);
__decorate([
    toccata_1.validator.IsInt()
], Shoutout.prototype, "processingFeeAmount", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(ShoutoutQuantity)
], Shoutout.prototype, "quantity", void 0);
__decorate([
    toccata_1.validator.IsInt(),
    toccata_1.validator.Min(3)
], Shoutout.prototype, "responseTimeDays", void 0);
__decorate([
    toccata_1.validator.IsString()
], Shoutout.prototype, "rules", void 0);
__decorate([
    toccata_1.validator.IsInt(),
    toccata_1.validator.Min(100)
], Shoutout.prototype, "unitPrice", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Shoutout.prototype, "updatedAt", void 0);
exports.Shoutout = Shoutout;
class RequestDownload extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsUrl()
], RequestDownload.prototype, "media", void 0);
__decorate([
    toccata_1.validator.IsUrl(),
    toccata_1.validator.IsOptional()
], RequestDownload.prototype, "previewImageUrl", void 0);
__decorate([
    toccata_1.validator.IsUrl()
], RequestDownload.prototype, "source", void 0);
__decorate([
    toccata_1.validator.IsUrl()
], RequestDownload.prototype, "view", void 0);
__decorate([
    toccata_1.validator.IsUrl()
], RequestDownload.prototype, "url", void 0);
exports.RequestDownload = RequestDownload;
class RequestError extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsNumber()
], RequestError.prototype, "count", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RequestError.prototype, "message", void 0);
exports.RequestError = RequestError;
class RequestShoutout extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.artistGroupName = '';
        this.introduction = '';
        this.responseTimeDays = 7;
    }
}
__decorate([
    toccata_1.validator.IsString()
], RequestShoutout.prototype, "artistGroupId", void 0);
__decorate([
    toccata_1.validator.IsString()
], RequestShoutout.prototype, "artistGroupName", void 0);
__decorate([
    toccata_1.validator.IsString()
], RequestShoutout.prototype, "introduction", void 0);
__decorate([
    toccata_1.validator.IsString()
], RequestShoutout.prototype, "name", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(ShoutoutAssets)
], RequestShoutout.prototype, "assets", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], RequestShoutout.prototype, "responseTimeDays", void 0);
exports.RequestShoutout = RequestShoutout;
class RequestForm extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString()
], RequestForm.prototype, "message", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.ValidateIf((o) => o.type === RequestFormType.someoneElse)
], RequestForm.prototype, "messageFor", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.ValidateIf((o) => o.type === RequestFormType.someoneElse)
], RequestForm.prototype, "relation", void 0);
__decorate([
    toccata_1.validator.IsString()
], RequestForm.prototype, "requestedBy", void 0);
__decorate([
    toccata_1.validator.IsString()
], RequestForm.prototype, "starter", void 0);
__decorate([
    toccata_1.validator.IsEnum(RequestFormType)
], RequestForm.prototype, "type", void 0);
exports.RequestForm = RequestForm;
class RequestFormPublic extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.ValidateIf((o) => o.type === RequestFormType.someoneElse)
], RequestFormPublic.prototype, "messageFor", void 0);
__decorate([
    toccata_1.validator.IsString()
], RequestFormPublic.prototype, "requestedBy", void 0);
__decorate([
    toccata_1.validator.IsEnum(RequestFormType)
], RequestFormPublic.prototype, "type", void 0);
exports.RequestFormPublic = RequestFormPublic;
class Request extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.status = RequestStatus.pending;
    }
}
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Request.prototype, "createdAt", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RequestDownload),
    toccata_1.validator.ValidateIf((o) => o.status === RequestStatus.completed)
], Request.prototype, "download", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RequestFormPublic),
    toccata_1.validator.IsOptional()
], Request.prototype, "form", void 0);
__decorate([
    toccata_1.validator.IsString({ each: true })
], Request.prototype, "fulfillerUids", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Request.prototype, "requestorUid", void 0);
__decorate([
    toccata_1.validator.IsString()
], Request.prototype, "shoutoutId", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RequestShoutout)
], Request.prototype, "shoutout", void 0);
__decorate([
    toccata_1.validator.IsEnum(RequestStatus)
], Request.prototype, "status", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Request.prototype, "sentAt", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Request.prototype, "updatedAt", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Request.prototype, "expiresAt", void 0);
exports.Request = Request;
/**
 * Get the metadata assigned to this source.  If a `key` is provided,
 * an attempt is made to retrieve the corresponding value.  If the `key`
 * if not found, `defaultValue` is returned.
 *
 * If no `key` is provided, the entire metadata object is returned.
 *
 * NOTE: Since `metatdata` is untyped, caution should be used here.
 */
const getRequestSourceMetadata = (source, key, defaultValue) => {
    const metadata = (source.metadata || {});
    if (key) {
        const descriptor = Object.getOwnPropertyDescriptor(metadata, key);
        return descriptor ? descriptor.value : defaultValue;
    }
    return metadata;
};
exports.getRequestSourceMetadata = getRequestSourceMetadata;
class RequestSource extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.label = '';
        this.metadata = {};
    }
}
__decorate([
    toccata_1.validator.IsString()
], RequestSource.prototype, "id", void 0);
__decorate([
    toccata_1.validator.IsString()
], RequestSource.prototype, "label", void 0);
__decorate([
    toccata_1.validator.IsEnum(RequestSourceType)
], RequestSource.prototype, "type", void 0);
__decorate([
    toccata_1.validator.IsObject()
], RequestSource.prototype, "metadata", void 0);
exports.RequestSource = RequestSource;
class RequestData extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.status = RequestStatus.pending;
    }
}
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], RequestData.prototype, "createdAt", void 0);
__decorate([
    toccata_1.validator.IsEmail()
], RequestData.prototype, "email", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RequestError),
    toccata_1.validator.IsOptional()
], RequestData.prototype, "error", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RequestForm)
], RequestData.prototype, "form", void 0);
__decorate([
    toccata_1.validator.IsString({ each: true })
], RequestData.prototype, "fulfillerUids", void 0);
__decorate([
    toccata_1.validator.IsPhoneNumber(),
    toccata_1.validator.IsOptional()
], RequestData.prototype, "phoneNumber", void 0);
__decorate([
    toccata_1.validator.IsString()
], RequestData.prototype, "requestorUid", void 0);
__decorate([
    toccata_1.validator.IsString()
], RequestData.prototype, "shoutoutId", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RequestSource)
], RequestData.prototype, "source", void 0);
__decorate([
    toccata_1.validator.IsEnum(RequestStatus)
], RequestData.prototype, "status", void 0);
__decorate([
    toccata_1.validator.IsEnum(RequestStatus),
    toccata_1.validator.IsOptional()
], RequestData.prototype, "previousStatus", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], RequestData.prototype, "updatedAt", void 0);
exports.RequestData = RequestData;
class RequestEvent extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.status = RequestStatus.unknown;
    }
}
__decorate([
    toccata_1.validator.IsEnum(RequestStatus)
], RequestEvent.prototype, "status", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RequestData)
], RequestEvent.prototype, "after", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RequestData),
    toccata_1.validator.IsOptional()
], RequestEvent.prototype, "before", void 0);
__decorate([
    toccata_1.validator.IsString()
], RequestEvent.prototype, "diff", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], RequestEvent.prototype, "createdAt", void 0);
exports.RequestEvent = RequestEvent;
//# sourceMappingURL=shoutouts.js.map